import Component from "react-pure-render/component";
import React, { PropTypes } from "react";

export default class ButtonWithAction extends Component {
  static propTypes = {
    action: PropTypes.func,
    actionParams: PropTypes.any,
    buttonText: PropTypes.string
  };

  action = () => {
    const { action, actionParams } = this.props;
    action(actionParams);
  };

  render() {
    const { buttonText } = this.props;
    return (
      <button className="error" onClick={this.action}>
        {buttonText}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/buttonWithAction.react.js